import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Positioning from './components/Positioning';
import ValueProposition from './components/ValueProposition';
import Industries from './components/Industries';
import Approach from './components/Approach';
import Differentiation from './components/Differentiation';
import Transformation from './components/Transformation';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Navigation />
      <Hero />
      <Positioning />
      <ValueProposition />
      <Industries />
      <Approach />
      <Differentiation />
      <Transformation />
      <FinalCTA />
      <Footer />
    </div>
  );
}
